import * as t from "io-ts";
import { RelevancyScore } from "../../../components/common";
import Avatar from "ui-components/avatar";
import { Tooltip } from "@blueprintjs/core";
import { Text, CustomCard, CustomTable } from "ui-components";
import { ReactElement } from "react";
import { TableComponent } from "../../../components";
import styled from "styled-components";

const TableColumnIdIO = t.union([
  t.literal("companyID"),
  t.literal("companyName"),
  t.literal("url"),
  t.literal("industry"),
  t.literal("sub_industry"),
  t.literal("highlights"),
  t.literal("latestFunding"),
  t.literal("foundingDate"),
  t.literal("headcountGrowth"),
  t.literal("stageOfFunding"),
  t.literal("relevancyScore"),
  t.literal("description"),
  t.literal("webTraffic90d"),
  t.literal("headcount"),
  t.literal("state"),
  t.literal("country"),
]);
type TableColumnIdT = t.TypeOf<typeof TableColumnIdIO>;
export type CompanyT = Record<TableColumnIdT, any>;

const tableColumns: { id: TableColumnIdT; label: string }[] = [
  { id: "companyName", label: "Name" },
  { id: "industry", label: "Industry" },
  { id: "highlights", label: "Industry Tags" },
  { id: "stageOfFunding", label: "Stage of Funding" },
  { id: "foundingDate", label: "Founding Date" },
  { id: "relevancyScore", label: "Relevancy Score" },
  { id: "description", label: "Description" },
  { id: "headcount", label: "Headcount" },
  { id: "headcountGrowth", label: "Headcount Growth" },
  { id: "webTraffic90d", label: "Web Traffic % (90d)" },
  { id: "latestFunding", label: "Latest Funding" },
  { id: "state", label: "State" },
  { id: "country", label: "Country" },
];

type Props = {
  title?: ReactElement;
  handleCompanyDetails?: (company: CompanyT) => void;
  fundingRoundData?: any[];
  isStickyFirstColumn?: boolean;
};

const CompanyTable = (props: Props) => {
  const { title, handleCompanyDetails, fundingRoundData, isStickyFirstColumn } =
    props;
  const data = fundingRoundData || [];

  return (
    <CustomCard>
      {title && title}
      <TableComponent minHeight="270px">
        <CustomTable isStickyFirstColumn={isStickyFirstColumn}>
          <thead>
            <tr>
              {tableColumns.map(({ id, label }) => (
                <th key={id}>{label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((row) => (
              <tr key={row.companyID}>
                {tableColumns.map(({ id: columnId }) => (
                  <td
                    key={row.companyID + columnId}
                    onClick={() =>
                      columnId === "companyName" &&
                      handleCompanyDetails &&
                      handleCompanyDetails(row)
                    }
                  >
                    {columnId === "companyName" ? (
                      <span className="display-flex align-center cursor-pointer space-normal">
                        <Avatar
                          email={"yantrix@gmail.com"}
                          profileUrl={row?.url?.logo || ""}
                          onlyAvatar={true}
                          displayName={row[columnId]}
                          isCircle={true}
                          isCurrentUser={false}
                          isLoading={false}
                          size="30px"
                        />
                        {row[columnId]}
                      </span>
                    ) : columnId === "relevancyScore" ? (
                      <RelevancyScore relevancyScore={row[columnId]} />
                    ) : columnId === "description" ? (
                      <Tooltip
                        popoverClassName={"w-400"}
                        transitionDuration={1000}
                        placement={"bottom"}
                        content={<TooltipContentWrapper>{row[columnId]}</TooltipContentWrapper>}
                      >
                        <Text ellipsis style={{ width: "200px" }}>
                          {row[columnId]}
                        </Text>
                      </Tooltip>
                    ) : columnId === "industry" ||
                      columnId === "state" ||
                      columnId === "country" ? (
                      <span className="text-capitalize">{row[columnId]}</span>
                    ) : (
                          row[columnId]
                        )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </CustomTable>
      </TableComponent>
    </CustomCard>
  );
};

export default CompanyTable;

const TooltipContentWrapper = styled.div`
  white-space: normal;
  overflow-wrap: break-word;
`;